import React from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import { Toolbar, ToolbarGroup, ToolbarTitle } from "material-ui/Toolbar";
import * as Colors from "material-ui/styles/colors";
import "./firmeDash.css";

const muiTheme = getMuiTheme({
  palette: {
    textColor: Colors.darkBlack,
    primary1Color: Colors.lightGreen600,
    primary2Color: Colors.indigo700,
    accent1Color: Colors.lightGreen600,
    pickerHeaderColor: Colors.darkBlack,
    alternateTextColor: Colors.white
  },
  appBar: {
    height: 45
  }
});



export default class CompanyDash extends React.Component {

  changePanelPoruka = (idFirme,text) =>{
    idFirme="PanelPoruka_" + idFirme;
    this.setState({[idFirme]: text})
  }

  updatePanelPoruka =(idFirme)=>{
    let state="PanelPoruka_" + idFirme
    try{
    this.props.putPanelPoruka(idFirme,this.state[state])
  }
  catch(e){console.log("Poruka nije menjana...")}
  }

  render() {
    return (
      <div
        className="firmaDash"
        style={{
          borderRadius: 5,
          WebkitFlex: "430px",
          marginBottom: 7,
          padding: 5,
          fontFamily: "Raleway,sans-serif",
          textAlign: "left",
          background: "rgba(254, 254, 122,1)",
          color: "rgba(0, 0, 0, 0.87)",
          fontSize: "14px",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <MuiThemeProvider muiTheme={muiTheme}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Toolbar
              style={{
                borderRadius: 5,
                height: 38,
                marign: 0,
                padding: 5,
                background:"#1abc9c"
              }}
            >
              <ToolbarGroup>
                <ToolbarTitle
                  style={{ margin: 0, color: "white" }}
                  text={this.props.name}
                />
              </ToolbarGroup>
            </Toolbar>


              <label style={{ paddingTop: 5 }}> 
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
               Rezervisano obroka trenutno*:
              </label>{" "}
              {this.props.numOfRes} ({this.props.numOfRes > this.props.ukupnoRezervisanoProslaNedelja
                      ? "📈" : "📉"} {Math.round((((this.props.ukupnoRezervisanoProslaNedelja-this.props.numOfRes)/this.props.ukupnoRezervisanoProslaNedelja)*100)*100)/100}%)
            </label>
             <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
              Rezervisano obroka protekle nedelje:
              </label>{" "}
              {this.props.ukupnoRezervisanoProslaNedelja}
            </label>

                                    <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
              Iskorišćeno obroka protekle nedelje:
              </label>{" "}
              {this.props.ukupnoKoristenoProslaNedelja}
            </label>


            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
              Aktivni korisnici mobilne aplikacije:
              </label>{" "}
              {this.props.brojKorisnikaMobilneAplikacije}
            </label>
            <label>
              <label
                style={{
                  fontWeight: "bold",
                  paddingLeft: 5,
                  color: "rgba(0, 0, 0, 0.87)"
                }}
              >
              Aktivni korisnici ukupno:
              </label>{" "}
              {this.props.brojAktivnihKorisnika}
            </label>




           
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Dash/MasterDash.js